// 栏目分类数据
export type Category = {
  id: string;
  slug: string;
  name: string;
  short: string;
  desc: string;
  count: number;
  icon: string;
  image: string;
};

export const categories: Category[] = [
  {
    id: 'stars',
    slug: 'stars',
    name: '明星动态',
    short: '明星',
    desc: '每日追踪一线明星动态，红毯造型、新作官宣、路透现场、社交互动一网打尽。',
    count: 1286,
    icon: 'ri-star-smile-line',
    image:
      'https://readdy.ai/api/search-image?query=Celebrity%20red%20carpet%20moment%20with%20elegant%20artist%20in%20glittering%20gown%2C%20flash%20photography%2C%20spotlight%20glare%2C%20editorial%20entertainment%20magazine%20style%2C%20warm%20cinematic%20tone%2C%20high%20detail&width=900&height=560&seq=cat-stars-01&orientation=landscape',
  },
  {
    id: 'variety',
    slug: 'variety',
    name: '综艺片段',
    short: '综艺',
    desc: '精选热播综艺高光片段，名场面、爆笑互动、金句盘点，承包你的快乐日常。',
    count: 976,
    icon: 'ri-mic-line',
    image:
      'https://readdy.ai/api/search-image?query=Colorful%20TV%20variety%20show%20studio%20stage%20with%20bright%20lights%2C%20cameras%20and%20applause%2C%20cheerful%20festive%20atmosphere%2C%20vibrant%20entertainment%20set%2C%20high%20energy%2C%20editorial%20photography&width=900&height=560&seq=cat-variety-01&orientation=landscape',
  },
  {
    id: 'film',
    slug: 'film',
    name: '影视花絮',
    short: '影视',
    desc: '电影电视剧幕后花絮与拍摄现场，导演采访、片场趣事、预告解析一次看个够。',
    count: 863,
    icon: 'ri-film-line',
    image:
      'https://readdy.ai/api/search-image?query=Movie%20production%20behind%20the%20scenes%20with%20film%20camera%20and%20clapperboard%2C%20cinematic%20studio%20lighting%2C%20creative%20team%20silhouette%2C%20dramatic%20mood%2C%20editorial%20film%20set%20photography&width=900&height=560&seq=cat-film-01&orientation=landscape',
  },
  {
    id: 'red',
    slug: 'red',
    name: '红人视频',
    short: '红人',
    desc: '头部短视频红人更新集合，生活方式、美食探店、创意短片，好内容随时追更。',
    count: 1502,
    icon: 'ri-video-line',
    image:
      'https://readdy.ai/api/search-image?query=Young%20influencer%20recording%20video%20with%20smartphone%20and%20ring%20light%20in%20cozy%20modern%20room%2C%20lifestyle%20content%20creation%2C%20warm%20natural%20light%2C%20editorial%20photography&width=900&height=560&seq=cat-red-01&orientation=landscape',
  },
];